module.exports = __webpack_public_path__ + "img/logo.546d4272.svg";